import { useQuery } from "react-query";
import { fetchPatientMessages, SMS_QUERY_KEYS } from "@/services/sms";
/**
 * Query hook for a patient's SMS history. Loads the initial state; subsequent
 * status changes are pushed live over the worklist socket (see useSmsStatusEvents).
 */
export function usePatientMessages(patientId) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useQuery(SMS_QUERY_KEYS.patientMessages(patientId), function () {
    return fetchPatientMessages(patientId);
  }, {
    enabled: Boolean(patientId) && enabled,
    staleTime: 0
  });
}